export default __webpack_public_path__ + "static/media/Group 7.875efc82.png";